var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_40364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16322 24.8368 0 16 0C7.16322 0 0 7.16322 0 16C0 23.504 5.16589 29.7996 12.1349 31.5291V20.8893H8.83552V16H12.1349V13.8933C12.1349 8.44699 14.5993 5.92283 19.9456 5.92283C20.9597 5.92283 22.7087 6.12212 23.4241 6.32079V10.753C23.0463 10.7134 22.3906 10.6933 21.5758 10.6933C18.9523 10.6933 17.9382 11.6872 17.9382 14.2711V16H23.1645L22.2667 20.8893H17.9382V31.8831C25.8609 30.9262 32 24.1804 32 16Z",
    fill: "#0866FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2671 20.8883L23.1649 15.999H17.9386V14.2702C17.9386 11.6863 18.9527 10.6923 21.5762 10.6923C22.391 10.6923 23.0467 10.7124 23.4245 10.7521V6.31983C22.7091 6.12117 20.9601 5.92188 19.946 5.92188C14.5997 5.92188 12.1353 8.44667 12.1353 13.8923V15.999H8.83594V20.8883H12.1353V31.5282C13.3731 31.835 14.6676 31.999 16.0004 31.999C16.6568 31.999 17.303 31.9588 17.9386 31.8821V20.8883H22.2671Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_40364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/facebook1.d7c38b3386bcae41bfa72387b14af172.svg";
export { ForwardRef as ReactComponent };